import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  logo: {
    display: 'block',
    width: 'auto',
    height: 70,
    objectFit: 'contain',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.logo} src="/hummingbird-icon.svg" alt="Zest" />;
};

export default LogoIcon;
